import { render, staticRenderFns } from "./OrderSelector.vue?vue&type=template&id=b3884ede&"
import script from "./OrderSelector.vue?vue&type=script&lang=js&"
export * from "./OrderSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports